import api from "../../api/axiosInstance";
import { adalConfig } from "../../common/endpoints";

// API function to fetch user projects
export const fetchUserProjects = async (tenantId: string, objectId: string) => {
  try {
    const response = await api.get(
       adalConfig?.endpoints?.getmultiappdata + `?tenantId=${tenantId}&objectId=${objectId}`
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "Something went wrong");
  }
};
